import { useState } from "react";
import Navbar from './header/Navbar';
import Footer from "./footer/Footer";
import { FaArrowCircleUp } from "react-icons/fa";

const Layout = ({children}) => {

  const [showScroll, setShowScroll] = useState(false);

  const checkScrollTop = () => {
    if (!showScroll && window.pageYOffset > 400){
      setShowScroll(true)
    } else if (showScroll && window.pageYOffset <= 400){
      setShowScroll(false)
    }
  }

  const scrollTop = () =>{
    window.scrollTo({top: 0, behavior: 'smooth'});
  }

  if (typeof window !== "undefined") {
    window.addEventListener('scroll', checkScrollTop);
  }

  return (
    <div className="flex flex-col justify-between">
      <Navbar />
      <div>
        <div className={`${process.env.NODE_ENV === "development" ? 'debug-screens' : '  '}${" bg-white"}`}>
          {children}
        </div>
        <FaArrowCircleUp className="scrollTop" onClick={scrollTop} style={{ display: showScroll ? 'block' : 'none'}}/>   
      </div>
      <Footer/>
    </div>
  )
}

export default Layout;
